import React, { useContext, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { DashboardContext } from "../context/Dashboard/DashboardContext";
import BackArrow from "./BackArrow";
import UserAvatar from "./UserAvatar";

const HeaderDashboard = ({ name, page, adm, back, onClick }) => {
  const { user } = useContext(DashboardContext);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 1326 });

  const exit = () => {
    localStorage.removeItem("@MAXITRANS_TOKEN_ADMIN:");
    localStorage.removeItem("@MAXITRANS_TOKEN_CLIENT:");
    navigate("/");
  };

  useEffect(() => {
    const tokenAdmin = localStorage.getItem("@MAXITRANS_TOKEN_ADMIN:");
    if (!tokenAdmin) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName = user?.name?.split(" ")[0] ?? "";

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "2.6875rem",
    paddingLeft: isDesktop ? "0" : "3.375rem",
    zIndex: "1",
    width: !isDesktop ? "95%" : undefined,
  };

  const userInfo = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "1.1rem",
    width: "234px",
    background: "white",
    border: "1.9px solid #d7d7d7",
    borderRadius: "60px",
    padding: "6px",
    paddingLeft: "20px",
    height: "54px",
    cursor: "pointer",
  };

  return (
    <div
      className="boxContainerHeader"
      style={{ width: "100%", background: "#F9F9F9" }}
    >
      <div className="containerHeader" style={headerStyle}>
        {page === "addStock" ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <BackArrow onClick={() => navigate("/dashboard/manage")} />
            <p className="textPrimaryHeaderDashboard">{name}</p>
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            {back && (
              <div
                style={{ position: "absolute", top: "11px", cursor: "pointer" }}
              >
                <BackArrow onClick={onClick} />
              </div>
            )}
            <p
              style={{ marginLeft: back ? "40px" : undefined }}
              className="textPrimaryHeaderDashboard"
            >
              {name}
            </p>
          </div>
        )}

        <div ref={dropdownRef} style={{ position: "relative" }}>
          <button
            style={userInfo}
            type="button"
            onClick={() => setDropdownOpen((o) => !o)}
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
          >
            <div style={{ position: "relative", right: "13px" }}>
              {user?.picture ? (
                <img
                  src={user.picture}
                  alt="Foto do usuário"
                  style={{
                    width: "40px",
                    height: "40px",
                    position: "absolute",
                    top: "-20px",
                    left: "0",
                    borderRadius: "60px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "0",
                  }}
                >
                  <UserAvatar name={user?.name} size={40} fontSize={14} />
                </div>
              )}
            </div>
            <p className="textClientInfoHeader">{displayName}</p>

            <svg
              width="8"
              height="8"
              viewBox="0 0 8 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.182668 1.78582C0.0688405 1.57763 0.0688405 1.32582 0.182668 1.11763C0.446809 0.634515 1.14065 0.634515 1.40479 1.11763L2.41937 2.97328C3.12207 4.25852 4.96793 4.25852 5.67064 2.97327L6.68521 1.11763C6.94935 0.634515 7.64319 0.634515 7.90733 1.11763C8.02116 1.32582 8.02116 1.57763 7.90733 1.78582L6.67725 4.03563C5.53942 6.11672 2.55058 6.11672 1.41275 4.03563L0.182668 1.78582Z"
                fill="black"
              />
            </svg>
          </button>

          {dropdownOpen && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "100%",
                marginTop: "4px",
                width: "234px",
                background: "#fff",
                border: "1px solid #d7d7d7",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                zIndex: 999,
              }}
            >
              <button
                onClick={exit}
                style={{
                  width: "100%",
                  padding: "10px 16px",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  fontFamily: "Popins-regular",
                  fontSize: "0.875rem",
                  color: "#3c3c43",
                }}
              >
                Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderDashboard;
